// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import {
  UserRole,
  userRoleLabelMap,
  userRoleSchema,
} from '@/account/api/types';
import { FilterMenu } from '@/components/filter-menu';

const DEFAULT_LABEL = 'Role';

interface Props {
  /**
   * The currently selected role values
   */
  value: UserRole[];

  /**
   * A callback fired when the selected role values change
   */
  onChange: (value: UserRole[]) => void;
}

/**
 * A filter menu component for filtering users by their role (admin/user)
 */
export function UserRoleFilterMenu(props: Props) {
  const options = userRoleSchema.options.map((role) => ({
    id: role,
    label: userRoleLabelMap[role],
    isActive: props.value.includes(role),
  }));

  const handleChangeOption = (id: UserRole, isActive: boolean) => {
    if (isActive) {
      return props.onChange([...props.value, id]);
    }

    props.onChange(props.value.filter((role) => role !== id));
  };

  return (
    <FilterMenu
      label={DEFAULT_LABEL}
      options={options}
      onChangeOption={handleChangeOption}
    />
  );
}
